<template>
  <div class="emoji-library" v-if="emojis.length > 0">
    <div class="emoji-title">
      <b>{{ $t('emoji.title') }}</b>
    </div>
    <div class="emoji-list">
      <div class="slide-control prev" @click.prevent="slidePrev" :class="{ hidden: isFirstSlide }">
        <font-awesome-icon :icon="['fas', 'chevron-left']"/>
      </div>
      <div class="slide-control next" @click.prevent="slideNext" :class="{ hidden: isLastSlide }">
        <font-awesome-icon :icon="['fas', 'chevron-right']"/>
      </div>
      <Hooper
          :itemsToShow="12"
          :itemsToSlide="12"
          ref="carousel"
          @slide="updateCarousel"
      >
        <slide v-for="(emoji, i) in emojis" :key="'emoji'+i">
          <div class="emoji-list__item" @click="addEmoji(emoji)">
            <img :src="host + emoji.icon"/>
          </div>
        </slide>
      </Hooper>
    </div>
  </div>
</template>

<script>
import { Hooper, Slide } from 'hooper';

export default {
  name: 'EmojiLibrary',
  components: {
    Hooper,
    Slide
  },

  data() {
    return {
      curSlide: 0
    }
  },

  computed: {
    host: function () {
      return this.$store.getters.host();
    },

    emojis: function () {
      return this.$store.getters.emojis
    },

    slideCount() {
      return Math.ceil(this.emojis.length / 12)
    },

    isFirstSlide() {
      return this.curSlide === 0
    },

    isLastSlide() {
      return this.curSlide >= this.slideCount
    }
  },

  methods: {
    addEmoji(emoji) {
      this.$store.commit('addEmojiToMap', emoji)
    },

    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      if((this.$refs.carousel.currentSlide/12)+1 < this.slideCount) {
        this.$refs.carousel.slideNext();
      }
    },

    updateCarousel(payload) {
      this.curSlide = payload.currentSlide;
    }
  }
}
</script>